/* global */
(function() {
    'use strict';

    angular.module('GorillaBoy')
    .controller('gbShareLinkModalCtrl', [
        '$q',
        '$rootScope',
        '$scope',
        '$translate',
        '$document',
        '$location',
        '$timeout',
        '$uibModalInstance',
        '$sce',
        '$window',
        'ClientMetricsService',
        'DocumentService',
        'MessageManager',
        'MessageProvider',
        'MetricEvents',
        'ResourceService',
        'AppConstants',
        'isFolder',
        'pendingShareType',
        'shareResourceId',
        'shareResourceName',
        'isAnonymous',
        'currentOwnerOrganizationId',
        'currentOwnerUsername',
        'OrganizationService',
        'BrowserService',
        'UserService',
        'SignalProvider',
        '$log',
        'FeatureManagerService',
        'Features',
        'EndpointConfig',
        'ShareLinkService',
        gbShareModalLinkController
    ]);

    function gbShareModalLinkController($q, $rootScope, $scope, $translate, $document, $location, $timeout, $uibModalInstance, $sce, $window, ClientMetricsService, DocumentService, MessageManager, MessageProvider, MetricEvents, ResourceService, AppConstants,
        isFolder, pendingShareType, shareResourceId, shareResourceName, isAnonymous, currentOwnerOrganizationId, currentOwnerUsername, OrganizationService, BrowserService, UserService, SignalProvider, $log, FeatureManagerService, Features, EndpointConfig, ShareLinkService) {

          var  SHARE_RESULT = {
              FEEDBACK_FAILURE: 'FAILED',
              SHARE_FAILURE: 'FAILURE'
          },
          RESOURCE = {
    			     DOCUMENT: 'DOCUMENT',
    			        FOLDER: 'FOLDER'
    		  },

          collaboratorTypes = AppConstants.CollaboratorTypes,
          globalRoles = AppConstants.GlobalRoles,
          VALIDATION_EXCEPTION_LINK_EXPIRATION_IN_PAST = 'The expiration date for direct share can\'t be in the past',
          VALIDATION_EXCEPTION_ANONYMOUS_SHARE_DISALLOW = 'The organization\'s sharing rule does not allow anonymous share for this principal',

          MIDNIGHT = {
      			HOUR: 23,
      			MINUTE: 59,
      			SECOND: 59
      		},
          EPOCH_BASE = 1000,
          
          MILLISECOND_IN_A_DAY = EPOCH_BASE * 60 * 60 * 24,

        	SHARE_LINK_SCOPE = {
            DISABLED: {
                name: 'DISABLED',
                title: $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_OFF'),
                detail: $translate.instant('MODAL.SHARE_MODAL.SHARE_LINK_SELECT_ACCESS_LEVEL'),
                detailForAmazonIdentifier: 'MODAL.SHARE_MODAL.SHARE_LINK_SELECT_ACCESS_LEVEL',
            },
        		SITE_VIEWER: {
          			name: 'SITE_VIEWER',
          			title: $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_VIEW'),
                    detail: (!isFolder)? $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER_DETAIL_FILE_SITENAME', {siteName: $location.host()})
                                    :$translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER_DETAIL_FOLDER_SITENAME', {siteName: $location.host()}),
                    detailForAmazonIdentifier: (!isFolder)? 'MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER_DETAIL_FILE_AMAZON'
                                    :'MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER_DETAIL_FOLDER_AMAZON',
                                },
        		SITE_CONTRIBUTOR: {
          			name: 'SITE_CONTRIBUTOR',
          			title: $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_VIEW_EDIT'),
                detail: (!isFolder)? $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR_DETAIL_FILE_SITENAME', {siteName: $location.host()})
                                    :$translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR_DETAIL_FOLDER_SITENAME', {siteName: $location.host()}),
                detailForAmazonIdentifier: (!isFolder)? 'MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR_DETAIL_FILE_AMAZON'
                                    :'MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR_DETAIL_FOLDER_AMAZON',
                },
            ANYONE: {
        	    	name: 'ANYONE',
        			  title: $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_PUBLIC'),
                detail: $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_ANYONE_DETAIL'),
                detailForAmazonIdentifier: 'MODAL.SHARE_MODAL.LINK_SCOPE_ANYONE_DETAIL',
        	   }
          },
          SHARING_SCOPE = {
        		ANYONE : 'ANYONE',
        		POWER_USER : 'POWERUSER'
        	},

          ANONYMOUS_ID = AppConstants.CollaboratorTypes.ANONYMOUS.toLowerCase(),
        	anonymousPrincipalId = null,
          organizationPrincipalId = null,

    	    anyoneLinkDocument = $document[0].createElement('a'),
    		  siteLinkDocument = $document[0].createElement('a'),
    		  siteLinkFolder = $document[0].createElement('a');

        	anyoneLinkDocument.href = '#/share/document/' + encodeURIComponent(shareResourceId);
        	siteLinkDocument.href = '#/document/' + encodeURIComponent(shareResourceId);
        	siteLinkFolder.href = '#/folder/' + encodeURIComponent(shareResourceId);

            $scope.isFolder = isFolder;
            $scope.isAmazonSite = EndpointConfig.isAmazonSite();
            $scope.enforceExpDateOnLinkSharing = FeatureManagerService.isFeatureEnabled(Features.UI.ENFORCE_EXP_DATE_ON_LINK_SHARING);
            $scope.isInheritedFileShareDisabled = FeatureManagerService.isFeatureEnabled(Features.UI.DISABLE_INHERITED_FILE_SHARE);
		      activate();

	        function activate() {
            $scope.inDialogMode = $uibModalInstance !== null;
            $scope.validInputParameters = true;

            // Note that this validation is not required for controller calls which happen in dialog mode.
            if(!$scope.inDialogMode && !validateInputParameters(isFolder, pendingShareType, shareResourceId, shareResourceName, isAnonymous, currentOwnerOrganizationId, currentOwnerUsername)){
                MessageManager.addErrorMessage(MessageProvider.shareLinkMissingInputParameters);
                $scope.validInputParameters = false;
                return;
            }

            $scope.shareCompletedLink = "/shareComplete.html?shareSucceeded=";
    	    	$scope.SHARE_LINK_SCOPE = SHARE_LINK_SCOPE;
    	    	$scope.RESOURCE = RESOURCE;
    	    	$scope.resourceType = (isFolder)? RESOURCE.FOLDER : RESOURCE.DOCUMENT;
    	    	$scope.isAnyoneLinkAdminAllowed = false;
    	    	$scope.link = {
    	    		expiryDate: null,
    	    		passCode: null,
    	    		scope: SHARE_LINK_SCOPE.DISABLED.name
    	    	};
    	    	$scope.previous = {
              scope: $scope.link.scope,
              passCode: $scope.link.passCode,
              expiryDate: $scope.link.expiryDate
            };
    	    	$scope.shareLink = undefined;

    	    	$scope.dateOptions = {
    	          	minDate: 0,
    	          	showOn: 'both'
    	      };

            $scope.inDialogMode = $uibModalInstance !== null;
            $scope.shareCompletedLink = "/shareComplete.html?shareSucceeded=";
            $scope.dateFormat = $translate.instant('MODAL.SHARE_MODAL.DATE_FORMAT');

            getShareLinkPrincipal();

            function copyShareLink() {

              	if (!$scope.isAnyoneLinkAdminAllowed && $scope.link.scope === SHARE_LINK_SCOPE.ANYONE.name) {
              		return;
              	}

               try {
                   var shareLink = $('#share-link');
                   shareLink.select();
                   var linkCopySucceeded = document.execCommand('copy');

                   if (linkCopySucceeded) {
                       shareLink.blur();
                   } else {
                       linkCopyFailedHandler();
                   }

               } catch (err) {
                   linkCopyFailedHandler();
               }

               function linkCopyFailedHandler() {
                   // We alert users to use ctrl + c instead.
                   $window.alert($translate.instant('MESSAGES.LINK_COPY_CLIPBOARD'));
               }
            }

            $scope.onShareLinkClick = function($event) {
                $event.target.select();
            };

            $scope.showDatepicker = function() {
                if ($scope.hasInheritedShareLink) return;
    	    	$('#link-expiration-date').datepicker('show');
    	    };

      	    $scope.onlyNumbers = function(text) {
              	var numberRegex = new RegExp('^\\d+$');

              	if(numberRegex.test(text) || text === ''){
              		$scope.previousValidPassword = text;
              	}else{
              		$scope.link.passCode = !!$scope.previousValidPassword ? $scope.previousValidPassword : '';
              	}
            };

            $scope.getAccessLevelMessageIdentifierForAmazonSite = function() {
                var accessLevelMessageIdentifier = "";
                switch($scope.link.scope){
                  case SHARE_LINK_SCOPE.DISABLED.name:
                        accessLevelMessageIdentifier = SHARE_LINK_SCOPE.DISABLED.detailForAmazonIdentifier;
                        break;
                  case SHARE_LINK_SCOPE.ANYONE.name:
                        accessLevelMessageIdentifier = SHARE_LINK_SCOPE.ANYONE.detailForAmazonIdentifier;
                        break;
                  case SHARE_LINK_SCOPE.SITE_VIEWER.name:
                        accessLevelMessageIdentifier = SHARE_LINK_SCOPE.SITE_VIEWER.detailForAmazonIdentifier;
                        break;
                  case SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name:
                        accessLevelMessageIdentifier = SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.detailForAmazonIdentifier;
                        break;
                }
  
                return accessLevelMessageIdentifier;
            };

      	    $scope.getAccessLevelMessage = function() {
              return $scope.getScopeDetailedMessage($scope.link.scope);
            };

            $scope.getScopeDetailedMessage = function(scope){
              var scopeDetailedMessage = "";
              switch(scope){
                case SHARE_LINK_SCOPE.DISABLED.name:
                      scopeDetailedMessage = SHARE_LINK_SCOPE.DISABLED.detail;
                      break;
                case SHARE_LINK_SCOPE.ANYONE.name:
                      scopeDetailedMessage = SHARE_LINK_SCOPE.ANYONE.detail;
                      break;
                case SHARE_LINK_SCOPE.SITE_VIEWER.name:
                      scopeDetailedMessage = SHARE_LINK_SCOPE.SITE_VIEWER.detail;
                      break;
                case SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name:
                      scopeDetailedMessage = SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.detail;
                      break;
              }

              return scopeDetailedMessage;
            };

            $scope.isInvalidOption = function(op){

                return op.name == SHARE_LINK_SCOPE.ANYONE.name && (isFolder || !$scope.isAnyoneLinkAdminAllowed) && $scope.linkInfoLoaded;
            };

            $scope.canDisplaySettings = function() {
                if ($scope.link.scope === SHARE_LINK_SCOPE.DISABLED.name) {
                    return false;
                }
                return !isFolder || $scope.enforceExpDateOnLinkSharing;
            };

            function showSave() {
                return $scope.previous.scope != SHARE_LINK_SCOPE.DISABLED.name &&
                       $scope.link.scope == SHARE_LINK_SCOPE.DISABLED.name;
            }

            function showCreateAndCopy() {
                return $scope.previous.scope == SHARE_LINK_SCOPE.DISABLED.name;
            }

            $scope.isSaveButtonEnabled = function() {
                if ($scope.link.scope !== SHARE_LINK_SCOPE.DISABLED.name) {
                    return $scope.enforceExpDateOnLinkSharing? !!$scope.link.expiryDate : true;
                }
                return $scope.previous.scope !== SHARE_LINK_SCOPE.DISABLED.name;
            };

            $scope.getSaveButtonMessage = function() {
                var buttonMessage;

                if (showSave()) {
                    buttonMessage = $translate.instant('MODAL.SHARE_MODAL.SAVE');
                } else if (showCreateAndCopy()) {
                    buttonMessage = $translate.instant('MODAL.SHARE_MODAL.LINK_CREATE_AND_COPY');
                } else if ($scope.hasInheritedShareLink) {
                    buttonMessage = $translate.instant('MODAL.SHARE_MODAL.COPY_LINK');
                } else {
                    buttonMessage = $translate.instant('MODAL.SHARE_MODAL.LINK_SAVE_AND_COPY');
                }

                return buttonMessage;
            };

      	    $scope.getScopeDisabledMessage = function() {
      	    	var message = null;
      	    	if (!isFolder && !$scope.isAnyoneLinkAdminAllowed) {
      	    		message = $translate.instant('MODAL.SHARE_MODAL.ANYONE_LINK_ADMIN_RESTRICTION');
      	    	} else if (isFolder) {
      	    		message = $translate.instant('MODAL.SHARE_MODAL.ANONYMOUS_DISABLED_FOLDER');
      	    	}

      	    	return message;
      	    };


            $scope.$watch('link.scope', function(newValue, oldValue) {

              	if (newValue && newValue === SHARE_LINK_SCOPE.ANYONE.name) {
                    $scope.shareLink = anyoneLinkDocument;
                } else if (newValue && newValue !== SHARE_LINK_SCOPE.ANYONE.name && newValue !== SHARE_LINK_SCOPE.DISABLED.name) {
                    $scope.shareLink = (isFolder)? siteLinkFolder : siteLinkDocument;
                } else {
                    $scope.shareLink = undefined;
                }

            }, true);

            // Save share link changes
            $scope.submitLinkRequest = function() {
                if ($scope.hasInheritedShareLink) {
                    ShareLinkService.copyLinkToClipboard($scope.shareLink);;
                    $uibModalInstance.close();
                    return;
                }

            	if (!$scope.isAnyoneLinkAdminAllowed && $scope.link.scope === SHARE_LINK_SCOPE.ANYONE.name) {
            		return;
            	}

              if (!$scope.isSaveButtonEnabled()) {
                return;
              }

              // check password are 4 digit before sending request
            	var fourDigitRegex = new RegExp('^\\d{1,4}$');
            	if ($scope.link.passCode && !fourDigitRegex.test($scope.link.passCode)) {
            		MessageManager.addErrorMessage(MessageProvider.linkUpdateFailPasscodeFormat);
            		return;
            	}

              if ($scope.link.scope !== SHARE_LINK_SCOPE.DISABLED.name) {
                copyShareLink();
              }

              var done = $q.defer(),
                promises = [];

            	promises.push(updateShareLinkPermission());

              if (promises.length === 0) {
              	if (isFolder) {
              		  ClientMetricsService.cancelLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                    ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);
              	} else {
              		  ClientMetricsService.cancelLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                    ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);
              	}
              }

              $q.all(promises).then(function success() {
                	if (isFolder) {
              		    ClientMetricsService.cancelLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                      ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);
              	  } else {
              		    ClientMetricsService.cancelLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                      ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);
              	  }

                  // there is no modal instance if this controller is invoked as part of a page.
                  if($scope.inDialogMode){
                        if($scope.link.scope == SHARE_LINK_SCOPE.DISABLED.name) {
                            MessageManager.addSuccessMessage(MessageProvider.linkDisabledSuccess);
                        } else  {
                            MessageManager.addSuccessMessage(MessageProvider.linkUpdatedAndCopiedSuccess);
                        }
                        $uibModalInstance.close({
                            isAnyoneLink: ($scope.link.scope === SHARE_LINK_SCOPE.ANYONE.name),
                            isSiteLink: ($scope.link.scope === SHARE_LINK_SCOPE.SITE_VIEWER.name || $scope.link.scope === SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name)
                        });
                  } else {
                        // resolve the promises.
                        done.resolve();

                        // for non dialog flow we complete by redirecting to share complete link with a query parameter indicating result.
                        $scope.changeWindowLocationHref($scope.shareCompletedLink + 'true');
                  }

                  done.resolve();

              }, function error(errorText) {

                  if (errorText.message === VALIDATION_EXCEPTION_LINK_EXPIRATION_IN_PAST) {
            			    MessageManager.addErrorMessage(MessageProvider.linkUpdateFailExpirationDateInPast);
                	} else if (errorText.message === VALIDATION_EXCEPTION_ANONYMOUS_SHARE_DISALLOW) {
                		  MessageManager.addErrorMessage(MessageProvider.linkUpdateFailAnyoneLinkDisallowed);
                  }else {
                    	MessageManager.addErrorMessage(MessageProvider.linkUpdateFail);
                	}

                  done.reject();
              });

                return done.promise;
            };

	      }

        function validateInputParameters(isFolder, pendingShareType, shareResourceId, shareResourceName, isAnonymous, currentOwnerOrganizationId, currentOwnerUsername){

            // if all the input parameters are null then return true.
            if(isFolder && pendingShareType && shareResourceId && shareResourceName && isAnonymous &&  currentOwnerOrganizationId && currentOwnerUsername){
                return true;
            }

            return false;
        }


        //update the sharelink permissions
        function updateShareLinkPermission() {
        	  var completed = $q.defer(),
        		    promises = [];

            if ($scope.link.scope != SHARE_LINK_SCOPE.DISABLED.name) {

            	if ($scope.link.scope === SHARE_LINK_SCOPE.ANYONE.name && organizationPrincipalId) {
            		promises.push(ResourceService.deleteResourcePermission(shareResourceId, organizationPrincipalId));
            	}else if($scope.link.scope !== SHARE_LINK_SCOPE.ANYONE.name && anonymousPrincipalId) {
            		promises.push(ResourceService.deleteResourcePermission(shareResourceId, anonymousPrincipalId));
            	}

            	// Create selected link
            	var shareLinkExpiration = ($scope.link.expiryDate)? $scope.link.expiryDate.setHours(MIDNIGHT.HOUR, MIDNIGHT.MINUTE, MIDNIGHT.SECOND) / EPOCH_BASE : null,
                	shareLinkPassword = ($scope.link.passCode)? $scope.link.passCode : null,
                	shareLinkPrincipalId,
                	shareLinkPrincipalType,
                	shareLinkPrincipalRole;
            	if ($scope.link.scope === SHARE_LINK_SCOPE.ANYONE.name && !isFolder) {
            		shareLinkPrincipalId = ANONYMOUS_ID;
            		shareLinkPrincipalType = collaboratorTypes.ANONYMOUS;
            		shareLinkPrincipalRole = globalRoles.VIEWER;
            	} else {
            		shareLinkPrincipalId = currentOwnerOrganizationId;
            		shareLinkPrincipalType = collaboratorTypes.ORGANIZATION;
            		shareLinkPrincipalRole = ($scope.link.scope === SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name)? globalRoles.CONTRIBUTOR : globalRoles.VIEWER;
            	}

                if ($scope.enforceExpDateOnLinkSharing){
                    if (!$scope.link.expiryDate) {
                        $scope.link.expiryDate = new Date(Date.now() + 30 * MILLISECOND_IN_A_DAY);
                    }
                    shareLinkExpiration = $scope.link.expiryDate.setHours(MIDNIGHT.HOUR, MIDNIGHT.MINUTE, MIDNIGHT.SECOND) / EPOCH_BASE;
                }

            	promises.push(ResourceService.updateLinkPermissions(shareResourceId, shareLinkPrincipalId, shareLinkPrincipalType, shareLinkPrincipalRole,
            	                                                    shareLinkExpiration, shareLinkPassword));

            } else {

            	// If exist, delete links
            	if (anonymousPrincipalId) {
            		promises.push(ResourceService.deleteResourcePermission(shareResourceId, anonymousPrincipalId));
            	}
            	if (organizationPrincipalId) {
            		promises.push(ResourceService.deleteResourcePermission(shareResourceId, organizationPrincipalId));
            	}

            }

            $q.all(promises).then(function resolveSuccess(responses) {

            	var errorMessage = null;
            	responses.forEach( function(response){
                  // send update signals
                  if (response.status === 204) {
                      $rootScope.$broadcast(SignalProvider.ShareLink.Deleted, {resourceId: shareResourceId});
                  } else if (response.status === 201) {
                      var resourceType = isFolder? RESOURCE.FOLDER : RESOURCE.DOCUMENT;
                      var linkScope = getSharedLinkScope(response.config.data);
                      $rootScope.$broadcast(SignalProvider.ShareLink.Created, {resourceType: resourceType, resourceId: shareResourceId, linkScope: linkScope});
                  }

              		if (response.data) {
              			response = response.data;
              			angular.forEach(response.ShareResults, function(value) {
                              if (!errorMessage && value.Status === SHARE_RESULT.SHARE_FAILURE) {
                              	errorMessage = value.StatusMessage;
                              }
                          });
              		}
            	});

            	if (errorMessage) {
                    completed.reject({
                        message: errorMessage
                    });
              } else {
                  completed.resolve();
              }

            }, function resolveError(reason) {
                completed.reject(reason);
            }).finally(function() {
                $rootScope.$broadcast(SignalProvider.Permission.PermissionUpdated);
            });

            return completed.promise;
        }

        function getSharedLinkScope(resourcePermissionsResponse) {
            var sharedLinkScope = null;
            resourcePermissionsResponse.Principals.forEach(function(principal) {
                if (principal.Type === 'ANONYMOUS') {
                    sharedLinkScope = SHARE_LINK_SCOPE.ANYONE.name;
                }
                if (principal.Type === 'ORGANIZATION') {
                    switch(principal.Role) {
                        case 'REVIEWER': 
                        case 'VIEWER':
                            sharedLinkScope = SHARE_LINK_SCOPE.SITE_VIEWER.name;
                            break;
                        case 'CONTRIBUTOR':
                            sharedLinkScope = SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name;
                            break;
                        default:
                            break;
                    }
                }
            });
            return sharedLinkScope;
        }

        function showPreviousShareLinkInfo(linkScope, linkSettings) {

          // show type of link
        	if (linkScope === SHARE_LINK_SCOPE.ANYONE.name) {
        		$scope.shareLink = anyoneLinkDocument;
        	} else if (linkScope === SHARE_LINK_SCOPE.DISABLED.name) {
            $scope.shareLink = undefined;
        	} else {
            $scope.shareLink = (isFolder)? siteLinkFolder : siteLinkDocument;
        	}

            $scope.link.expiryDate = (linkSettings.ExpirationDate)? new Date(linkSettings.ExpirationDate * EPOCH_BASE) : null;
            if ($scope.enforceExpDateOnLinkSharing && linkSettings.ExpirationDate === undefined) { 
                // Apply default 30 days expiration when enforceExpDateOnLinkSharing feature is enabled and the resource is not currently shared.
                $scope.link.expiryDate = new Date(Date.now() + 30 * MILLISECOND_IN_A_DAY);
            }
        	$scope.link.passCode = linkSettings.Password;
        	$scope.link.scope = linkScope;

            // data when modal is displayed
            $scope.previous.scope = $scope.link.scope;
            $scope.previous.passCode = $scope.link.passCode;
            $scope.previous.expiryDate = $scope.link.expiryDate;

            // all the info has been loaded
            $scope.linkInfoLoaded = true;
        }

        function getShareLinkPrincipal() {

        	getLinkAdminControls().then(function success(response){
        		$scope.isAnyoneLinkAdminAllowed = response.isAnyoneLinkAllowed;

        		ResourceService.describeResourcePermissions(shareResourceId, ['PRINCIPALS']).then(function success(response) {
                    response = response.data ? response.data : {};

                    var organizationPrincipalRole = null,
                    	anonShareSettings = {},
                    	orgShareSettings = {};

                    angular.forEach(response.Principals, function(principal){
                    	if(principal.Type === collaboratorTypes.ANONYMOUS) {
                    		anonymousPrincipalId = principal.Id;
                    		anonShareSettings = principal.ShareSettings;
                    	}
                    	if(principal.Type === collaboratorTypes.ORGANIZATION) {
                    		organizationPrincipalId = principal.Id;
                    		organizationPrincipalRole = principal.Roles[0].Role;
                    		orgShareSettings = principal.ShareSettings;
                    	}
                    });

                    if (anonymousPrincipalId) {
                    	showPreviousShareLinkInfo(SHARE_LINK_SCOPE.ANYONE.name, anonShareSettings);

                    } else if (organizationPrincipalId) {
                    	var linkScope = (organizationPrincipalRole === globalRoles.CONTRIBUTOR)? SHARE_LINK_SCOPE.SITE_CONTRIBUTOR.name : SHARE_LINK_SCOPE.SITE_VIEWER.name;
                    	showPreviousShareLinkInfo(linkScope, orgShareSettings);

                    } else {
                      showPreviousShareLinkInfo(SHARE_LINK_SCOPE.DISABLED.name, {});
                    }

                }, function error(err) {
                	$log.error(err);
                    if($scope.inDialogMode){
                	     $uibModalInstance.close({ isAnyoneLink: false, isSiteLink: false });
                    } else {
                        // for non dialog flow we complete by redirecting to share complete link with a query parameter indicating result.
                        $scope.changeWindowLocationHref($scope.shareCompletedLink + 'false');
                    }

                });

        	}, function error(err){
        		$log.error(err);
                if($uibModalInstance){
        		        $uibModalInstance.close({ isAnyoneLink: false, isSiteLink: false });
                } else {
                    // for non dialog flow we complete by redirecting to share complete link with a query parameter indicating result.
                    $scope.changeWindowLocationHref($scope.shareCompletedLink + 'false');
                }
        	});

        }

        function getLinkAdminControls() {
        	var done = $q.defer(),
        	    promises = [],
        	    isAnyoneLinkAllowed = false;

        	promises.push(OrganizationService.getOrganization());
        	promises.push(UserService.getUser());

        	$q.all(promises).then(function(response){

        		var Organization = response[0].data.Organization,
        			User = response[1].data.User;

        		if ( Organization.SharingRule.Scope === SHARING_SCOPE.ANYONE ||
        		    (Organization.SharingRule.Scope === SHARING_SCOPE.POWER_USER && (User.Administrator || User.Poweruser)) ) {

        			isAnyoneLinkAllowed = true;
    			  }

        		done.resolve({
        			isAnyoneLinkAllowed: isAnyoneLinkAllowed
        		});

        	}, function(error){
        		done.reject(error);
        	});

        	return done.promise;

        }

        $scope.getPermissions = function () {
            if (!$scope.isInheritedFileShareDisabled) return;
            ResourceService.describeResourcePermissions(shareResourceId, ['PRINCIPALS'])
                .success(function(response) {
                    $scope.hasInheritedShareLink = _.chain(response.Principals)
                        .filter(function (i) { return i.Type === "ORGANIZATION" })
                        .flatMap(function (i) { return i.Roles })
                        .some(function (i) { return i.Type === "INHERITED" })
                        .value();
                });
        }

        $scope.getPermissions();

    }

}());
